<template>
  <b-message :type="type" :auto-close="autoClose" :duration="6000" @close="$emit('close')">
    <div class="media media-align-center">
      <div class="media-left bar-msg-left"></div>
      <div class="media-left ml-15 mr-10">
        <b-icon :icon="icon" size="mdi-24px"></b-icon>
      </div>
      <div class="media-content has-text-grid-1">
        <div class="content is-size-7 py-10">
          <p v-for="(el, index) in msgErrors" :key="index">
            {{el}}
          </p>
        </div>
      </div>
    </div>
  </b-message>
</template>

<script>
export default {
  props: {
    msg: String,
    type: String,
    msgs: Array,
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    icon() {
      if (this.type === 'is-danger') return 'alert-outline';
      return '';
    },
    msgErrors() {
      if (this.msg) return [this.msg];
      return this.msgs ? this.msgs : []
    }
  },
};
</script>

<style>

</style>
